"use strict";

exports.__esModule = true;
var _CalendarEventConfigDetails = require("./CalendarEventConfigDetails");
Object.keys(_CalendarEventConfigDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarEventConfigDetails[key]) return;
  exports[key] = _CalendarEventConfigDetails[key];
});